import React from 'react';
export const CFIconCFG = {
    alias: 'cfg',
    defaultTitle: 'CFG',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M13.033 3.22a.75.75 0 0 0-1.063 0C10.106 5.082 8.046 6 5.75 6a.75.75 0 0 0-.75.75v4.501c0 4.829 2.462 8.11 7.263 9.71.154.051.32.051.474 0 4.8-1.6 7.263-4.881 7.263-9.71V6.75a.75.75 0 0 0-.75-.75c-2.297 0-4.357-.915-6.217-2.78Zm3.748 6a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.062 0l-2.25-2.25a.75.75 0 1 1 1.062-1.061l1.719 1.72 3.969-3.969a.75.75 0 0 1 1.062 0Z' }))),
};
